import React from 'react';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import { CircularProgress, Box } from '@material-ui/core';
import EmailLogViewer from '../../components/EmailPlatform/EmailLogViewer';
import { withSnackbar } from 'notistack';

const GET_EMAIL_LOGS = gql`
  query GetEmailLogs(
    $userId: Int
    $templateId: Int
    $sequenceId: Int
    $triggerId: Int
  ) {
    emailLogs(
      userId: $userId
      templateId: $templateId
      sequenceId: $sequenceId
      triggerId: $triggerId
    ) {
      id
      sentAt
      openedAt
      clickedAt
      subject
      bodyHtml
      templateVersion
      recipientEmail
      user {
        id
        name
        email
      }
      sentBy {
        id
        name
      }
      emailTemplate {
        id
        name
      }
      sequence {
        id
        name
      }
      trigger {
        id
        name
        event_type
      }
    }
    emailTemplates {
      id
      name
    }
    emailSequences {
      id
      name
    }
    email_triggers {
      id
      name
      event_type
    }
  }
`;

class EmailLogViewerContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filters: {
        userId: null,
        templateId: null,
        sequenceId: null,
        triggerId: null,
        startDate: null,
        endDate: null,
      },
    };
  }

  handleFilterChange = (newFilters) => {
    this.setState({
      filters: {
        ...this.state.filters,
        templateId: newFilters.templateFilter,
        sequenceId: newFilters.sequenceFilter,
        triggerId: newFilters.triggerFilter,
      },
    });
  };

  handleExportCSV = (csvData) => {
    this.props.enqueueSnackbar(`Exported ${csvData.length} records to CSV`, {
      variant: 'success',
    });
  };

  render() {
    const { filters } = this.state;

    return (
      <Query query={GET_EMAIL_LOGS} variables={filters}>
        {({ loading, error, data }) => {
          if (loading) {
            return (
              <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
                <CircularProgress />
              </Box>
            );
          }

          if (error) {
            return <div>Error loading email logs: {error.message}</div>;
          }

          // Map sequence to emailSequence for component compatibility
          const logs = (data.emailLogs || []).map(log => ({
            ...log,
            emailSequence: log.sequence,
            emailTrigger: log.trigger,
          }));

          return (
            <EmailLogViewer
              logs={logs}
              templates={data.emailTemplates || []}
              sequences={data.emailSequences || []}
              triggers={data.email_triggers || []}
              onFilterChange={this.handleFilterChange}
              onExportCSV={this.handleExportCSV}
            />
          );
        }}
      </Query>
    );
  }
}

export default withSnackbar(EmailLogViewerContainer);

